import { useParams, useNavigate } from "react-router-dom";
import { EditTrainingPage } from "@/pages/EditTrainingPage";
import { useAdminChatOutlet } from "./AdminChatUserLayout";
import { tg } from "@/constants/telegram";
import { User } from "@/entities/user";

export const AdminChatEditTrainingPage = () => {
  const { userId } = useAdminChatOutlet();
  const { id } = useParams();

  return (
    <EditTrainingPage
      initData={tg.initData || ""}
      user={{} as User}
      fromUser={userId}
      isAdmin={true}
    />
  );
};






















